(function() {
    $ = jQuery = fp.$ = window.jQuery.noConflict(true);
    _ = fp._ = window._.noConflict(true);

    dateFns = fp.dateFns;

    NProgress = fp.NProgress = window.NProgress;
    delete window.NProgress;

    if(typeof oldNProgress === 'object') {
        window.NProgress = oldNProgress;
        oldNProgress = undefined;
    }

    showdown = fp.showdown = window.showdown;
    delete window.showdown;

    if(typeof oldShowdown === 'object') {
        window.showdown = oldShowdown;
        oldShowdown = undefined;
    }

    S = fp.S = window.S;
    delete window.S;

    if(typeof oldS === 'object') {
        window.S = oldS;
        oldS = undefined;
    }

    numeral = fp.numeral = window.numeral;
    delete window.numeral;

    if(typeof oldNumeral === 'object') {
        window.numeral = oldNumeral;
        oldNumeral = undefined;
    }

    Lockr = fp.Lockr = window.Lockr;
    delete window.Lockr;

    if(typeof oldLockr === 'object') {
        window.Lockr = oldLockr;
        oldLockr = undefined;
    }

    //test if browser supports localStorage
    try {
        var item = 'fp';
        localStorage.setItem(item, item);
        localStorage.removeItem(item);
    }
    catch(exc) {
        Lockr = fp.Lockr = {
            set: $.noop,
            get: $.noop,
            rm: $.noop,
            flush: $.noop
        };
    }

    $.jMaskGlobals = {
        dataMask: false,
        watchDataMask: false
    };

    fp.jss = jss;

    //configure notifier (Bugsnag)
    bugsnag = window.bugsnag;
    delete window.bugsnag;

    if(typeof oldBugsnag === 'object') {
        window.bugsnag = oldBugsnag;
        oldBugsnag = undefined;
    }

    let isDev = fp.isDev(),
        enableBugsnag = !isDev;

    //removeIf(!debug)

    // isDev = false;
    // enableBugsnag = true;
    // enableBugsnag = false;

    //endRemoveIf(!debug)

    if(bugsnag && enableBugsnag && window.location.protocol.indexOf('http') === 0) {
        bugsnag.user = fp.notifier.user;
        bugsnag.metaData = fp.notifier.metaData;

        const fieldMask = 'XXXXXXXXX',
            maskFieldRegExps = _.map([
                'password',
                'card_number',
                'cardholder_name',
                'cvv'
            ], function(value) {
                return new RegExp('[\?&\.]' + value + '=([^&#]*)');
            });

        fp.notifier = bugsnag({
            apiKey: fp.bugsnagApiKey,
            appVersion: '1.0.0',
            releaseStage: fp.isProd() ? 'production' : 'staging',
            notifyReleaseStages: ['staging', 'production'],
            metaData: fp.notifier.metaData,
            user: fp.notifier.user,
            beforeSend: function (report) {
                const notifierUser = report.user,
                    errorClass = (report.errorClass || '').toLowerCase();

                let errorMessage = S(report.errorMessage),
                    isWhitelisted = true;

                fp.ui.applyErrorMeta(report);

                notifierUser.id = fp.user.id;
                notifierUser.session = fp.session.token;
                notifierUser.selected_store_id = fp.getSelectedStoreId();
                notifierUser.order_id = fp.session.preference.order_id;

                //don't send ApiError that has no status field
                if(errorClass === 'apierror' && !report.metaData['meta data'].Status) {
                    isWhitelisted = false;
                }

                if(!isDev && isWhitelisted) {
                    const bugsnagConfig = fp.config?.bugsnag || {},
                        host = S(window.location.host).toLowerCase(),
                        firstFile = S(report.stacktrace[0]?.file);

                    let isHostedFile = true;
                        
                    if(
                        firstFile.contains(fp.assetBaseUrl) ||
                        firstFile.contains(fp.assetCdnBaseUrl) ||
                        !(firstFile.contains(host.s) || firstFile.match(/https?:\/\//))
                    ) {
                        isHostedFile = false;
                    }

                    const isBlacklisted = _.find(bugsnagConfig.blacklist?.errorMessage, function(item) {
                        if(item.rule && _.isFunction(errorMessage[item.rule]) && errorMessage[item.rule](item.value)) {
                            if(item.errorClass) {
                                return item.errorClass === errorClass;
                            }
                            else if(item.hostname) {
                                if(item.hostname === 'hosted' && isHostedFile) {
                                    return true;
                                }
                                else {
                                    return host.contains(item.hostname);
                                }
                            }
                            return true;
                        }
                    });

                    if(isBlacklisted) {
                        return false;
                    }

                    let apiUrl = metaData['API Url'];
                    if (apiUrl) {
                        _.each(maskFieldRegExps, function (item) {
                            apiUrl = apiUrl.replace(item, function (match, group) {
                                return match.substr(0, match.length - group.length) + fieldMask;
                            });
                        });
                        metaData['API Url'] = apiUrl;
                        metaData['API Base URL'] = apiUrl.split('?')[0];

                        //don't send products/ads AbortError to bugsnag
                        if (errorClass === 'aborterror') {
                            if(fp.config?.enableAbortErrorLog === false) return false;
                            const apiBaseUrl = S(metaData['API Base URL']);
                            const disableApi = _.find(fp.config?.disableAbortErrorLogApis, function(item) {
                                return (!item.appKey || item.appKey === fp.appKey) ? apiBaseUrl.endsWith(item.path) : false;
                            });
                            if(disableApi) return false;
                        }
                    }

                    if (!report.stacktrace) return true;

                    // Check if any non-whitelisted urls exist in stacktrace. If so we will not send this error
                    const matchUrls = new RegExp('https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}', 'gmi'),
                        whitelistedDomains = 'freshop.com|cloudfront.net|stackpathdns.com|' + S(fp.assetCdnBaseUrl).trimRight('/').s + '|' + host.trimLeft('www.').replace(/([.])/g, '\\$1').s,
                        matchWhitelist = new RegExp(whitelistedDomains, 'i');

                    //reduce the number of category errors tracked (only track one per page load)
                    if(errorMessage.contains('CategoryError: More than one top level')) {
                        isWhitelisted = false;
                    }

                    if(isWhitelisted) {
                        //cannot replicate this error, only occurs for annonymous sessions Windows 10, Chrome v106.0.0
                        const hasUndefinedCallbacks = errorClass == 'typeerror' && errorMessage.contains('Cannot read properties of undefined (reading \'callbacks\')');

                        //cannot replicate this error, only occurs for Safari
                        const hasUndefinedContext = errorClass == 'typeerror' && errorMessage.contains('undefined is not an object (evaluating \'r["@context"].toLowerCase\')');
                        
                        let file,
                            method;
                        _.find(report.stacktrace, function (item) {
                            file = S(item.file);
                            method = S(item.method);
                            
                            const isGlobalCode = !file.length || file.trimRight('/').eq(location.origin) || method.contains('global code') || method.contains('unknown');
                            if (isGlobalCode && (hasUndefinedCallbacks || hasUndefinedContext)) {
                                isWhitelisted = false;
                            }
                            else {
                                const isFileBlacklisted = _.find(bugsnagConfig.blacklist?.file, function(item) {
                                    if(item.rule && _.isFunction(file[item.rule]) && file[item.rule](item.value)) {
                                        if(item.errorMessage?.rule && _.isFunction(errorMessage[item.errorMessage.rule])) {
                                            return errorMessage[item.errorMessage.rule](item.errorMessage.value);
                                        }
                                        return true;
                                    }
                                });
                                
                                isWhitelisted = !isFileBlacklisted;
                            }

                            if(isWhitelisted) {
                                matchUrls.lastIndex = 0;
                                _.find(file.match(matchUrls), function (value) {
                                    if (!value.match(matchWhitelist)) {
                                        isWhitelisted = false;
                                        return true;
                                    }
                                });
                            }

                            return !isWhitelisted;
                        });
                    }

                    //Tag errors that occur in Freshop JS files
                    if(
                        !isHostedFile &&
                        report.stacktrace &&
                        !_.contains(errorClass, ['aborterror', 'trackingerror', 'submitwarning'])
                    ) {
                        metaData['Tag'] = 'MonitorOnPush';
                    }
                    else {
                        metaData['Tag'] = 'IgnoreOnPush';
                    }
                }

                if(!fp.isProd() || fp.getPrefCookie().log_error) {
                    if (!errorMessage.startsWith(report.errorClass + ':')) {
                        errorMessage = S(fp.util.formatString(
                            '{0}: {1}',
                            report.errorClass,
                            errorMessage.s
                        ));
                    }
                    fp.logError(errorMessage.s);
                    fp.log('metaData:', metaData);
                }

                return isWhitelisted;
            }
        });
    }
})();